import {useState} from "react";
import {Circle} from "react-konva";
import type {ImagePoint} from "@/dungeons/model/DungeonGeometry.ts";
import type {DungeonFormOutput} from "@/dungeons/admin/form/DungeonFormSchema.ts";
import DungeonCanvasViewport from "@/dungeons/editor/shared/DungeonCanvasViewport.tsx";
import type {DungeonViewport} from "@/dungeons/editor/shared/DungeonViewport.ts";
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from "@/components/ui/dialog.tsx";

type Level = DungeonFormOutput["levels"][number];

export default function TransitionArrivalPicker({level, position, open, onOpenChange, onPick}: {
    level: Level;
    position?: ImagePoint | null;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onPick: (position: ImagePoint) => void;
}) {
    const [viewport, setViewport] = useState<DungeonViewport>();
    return <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="flex h-[80vh] w-[90vw] max-w-[90vw] flex-col">
            <DialogHeader>
                <DialogTitle>Ankunftspunkt auf „{level.name}“ setzen</DialogTitle>
                <DialogDescription>Klicke auf die Karte. Mittlere Maustaste verschiebt, das Mausrad zoomt.</DialogDescription>
            </DialogHeader>
            <div className="min-h-0 flex-1 overflow-hidden rounded-md border">
                <DungeonCanvasViewport image={level.map.image} geometry={level.geometry}
                    viewport={viewport} onViewportChange={setViewport} panButtons={["middle"]}
                    onMapClick={({point}) => onPick({x: Math.round(point.x * 10_000) / 10_000,
                        y: Math.round(point.y * 10_000) / 10_000})}
                    renderInteraction={zoom => position && <Circle x={position.x} y={position.y}
                        radius={8 / zoom} fill="#22c55e" stroke="white" strokeWidth={2 / zoom}
                        listening={false}/>}/>
            </div>
        </DialogContent>
    </Dialog>;
}
